<template>
    <div>
        <Tabs sticky key="device" v-if="selectedBar=='device'" v-model="deviceTab" @click="changeDeviceTab" swipe-threshold>
            <Tab title="控制面板" name="operation" v-if="device.uicomponentUrl !== null" key="operation">
                <OperationPanel :device="device" />
            </Tab>
            <Tab title="基础信息" name="baseInfo" key="baseInfo">
                <DeviceBaseInfo :device="device" :deviceId="deviceId"  />
            </Tab>
            <pf code="DEVICE_ACTION">
                <Tab title="远程控制" name="control" key="control">
                    <DeviceControl/>
                </Tab>
            </pf>
            <Tab title="加装配件" name="addTask" key="addTask">
                <PartList/>
            </Tab>
            <Tab v-if="device.productType =='Gateway'" title="子设备" name="childDevice" key="childDevice">
                <ChildDevice/>
            </Tab>
        </Tabs>
        <!--<Tabs sticky  key="alarm" v-if="selectedBar=='alarm'" v-model="alarmTab" @click="changeAlarmTab">-->
            <AlarmList  v-if="selectedBar=='alarm'"/>
        <!--</Tabs>-->
        <Tabs sticky key="log" v-if="selectedBar=='log'" v-model="logTab" @click="changeLogTab">
            <Tab title="事件记录" name="event">
                <LogEvent/>
            </Tab>
            <Tab title="控制记录" name="action">
                <LogAction/>
            </Tab>
            <Tab title="其他记录" name="other">
                <LogOther/>
            </Tab>
        </Tabs>
        <Analysis v-if="selectedBar=='analysis'"/>
        <Tabbar v-model="selectedBar">
            <TabbarItem name="device" icon="home-o">设备</TabbarItem>
            <TabbarItem name="alarm" icon="search">告警</TabbarItem>
            <TabbarItem name="log" icon="friends-o">记录</TabbarItem>
            <TabbarItem name="analysis" icon="setting-o">分析</TabbarItem>
        </Tabbar>
    </div>
</template>

<script>
    import {Tab, Tabbar, TabbarItem, Tabs} from "vant";
    import DeviceBaseInfo from "./tab/DeviceBaseInfo"
    import DeviceControl from "./tab/DeviceControl"
    import AlarmList from "./tab/AlarmList"
    import LogEvent from "./tab/LogEvent"
    import LogAction from "./tab/LogAction"
    import LogOther from "./tab/LogOther"
    import Analysis from "./tab/Analysis"
    import PartList from "./tab/PartList";
    import ChildDevice from "./tab/ChildDevice"
    import OperationPanel from "./tab/OperationPanel"
    import {setUnitId} from "@/utils/deviceId2unitId"

    export default {
        components: {
            PartList,
            Tabbar, TabbarItem, Tab, Tabs,
            DeviceBaseInfo, DeviceControl,
            AlarmList,
            LogEvent, LogOther, LogAction,
            Analysis, ChildDevice,OperationPanel
        },
        props: {},
        data() {
            return {
                show:false,
                gatewayShow:false,
                deviceId: this.$route.params.id,
                selectedBar: 'device',
                deviceTab: 'baseInfo',
                alarmTab: 'realTime',
                logTab: 'event',
                device: {image1: [], image2: [], image3: [], image4: [], productType: ''},
            }
        },
        computed: {
            
        },
        created() {
            this.getDevice()
        },
        mounted() {
           
        },
        methods: {
            getDevice() {
                this.$http.tokiot.device.get({id: this.deviceId,getUnitGroup:true})
                    .then(res => {
                        if (res) {
                            this.device = res
                            setUnitId(res.id,res.unitId)
                            // this.gatewayShow = this.device.productType=='Gateway'
                            if (this.device.uicomponentUrl !== null) {
                                this.show = true
                                this.deviceTab = 'operation'
                            } 
                        }
                        console.info('this.deviceTab =',this.deviceTab)
                    })
            },
            changeDeviceTab(key, title) {
                this.deviceTab = key
            },
            changeAlarmTab(key, title) {
                this.alarmTab = key
            },
            changeLogTab(key, title) {
                this.logTab = key
            }
        },
        watch: {}
    }
</script>

<style lang="less">
</style>
